import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAdsApi,
  createAdsApi,
  updateAdsApi,
  deleteAdsApi,
} from "./adsApi";

export const getAds = createAsyncThunk(
  "ads/getAds",
  async ({ page, limit, search, locationId }, thunkAPI) => {
    try {
      const res = await getAdsApi({ page, limit, search, locationId });
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to fetch ads"
      );
    }
  }
);

export const createAds = createAsyncThunk(
  "ads/createAds",
  async (data, thunkAPI) => {
    try {
      const res = await createAdsApi(data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const updateAds = createAsyncThunk(
  "ads/updateAds",
  async ({ id, data }, thunkAPI) => {
    try {
      const res = await updateAdsApi(id, data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const deleteAds = createAsyncThunk(
  "ads/deleteAds",
  async (id, thunkAPI) => {
    try {
      await deleteAdsApi(id);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

const adsSlice = createSlice({
  name: "ads",
  initialState: {
    ads: [],
    total: 0,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAds.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAds.fulfilled, (state, action) => {
        state.loading = false;
        state.ads = action.payload?.items || [];
        state.total = action.payload?.total || 0;
      })
      .addCase(getAds.rejected, (state) => {
        state.loading = false;
      })

      .addCase(createAds.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(updateAds.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(deleteAds.fulfilled, (state, action) => {
        state.ads = state.ads.filter((a) => a.id !== action.payload);
      });
  },
});

export default adsSlice.reducer;